import { arrayToObject } from '@/utils/object'
import { notify } from '@/utils/error'

export const loadItemsBuilder = ({ apiEndpoint }) => ({ commit, rootState }, data) => {
  return new Promise((resolve, reject) => {
    import('@/api/' + apiEndpoint)
      .then(({ default: api }) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        const filters = data ? data.filters : {}
        api.getAll({ businessUnitId, filters })
          .then(response => {
            const items = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
      .catch(error => {
        notify(error)
        reject(error)
      })
  })
}

export const loadItemBuilder = ({ apiEndpoint }) => ({ commit, rootState }, id) => {
  return new Promise((resolve, reject) => {
    import('@/api/' + apiEndpoint)
      .then(({ default: api }) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        api.getById({ businessUnitId, id })
          .then(response => {
            const item = response.data.items[0]
            commit('setElement', { type: 'items', id, element: item })
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
      .catch(error => {
        notify(error)
        reject(error)
      })
  })
}

export const saveItemBuilder = ({ apiEndpoint }) => ({ commit, rootState }, item) => {
  return new Promise((resolve, reject) => {
    import('@/api/' + apiEndpoint)
      .then(({ default: api }) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        api.save({ businessUnitId, item })
          .then(response => {
            const itemId = response.data.items[0].id
            commit('setElement', { type: 'items', id: itemId, element: { id: itemId, ...item } })
            resolve({ ...item, id: itemId })
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
      .catch(error => {
        notify(error)
        reject(error)
      })
  })
}

export const deleteItemBuilder = ({ apiEndpoint }) => ({ commit, rootState }, id) => {
  return new Promise((resolve, reject) => {
    import('@/api/' + apiEndpoint)
      .then(({ default: api }) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        api.delete({ businessUnitId, id })
          .then(response => {
            commit('removeElement', { type: 'items', id })
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
      .catch(error => {
        notify(error)
        reject(error)
      })
  })
}
